<div class="card-wrapper">
  <figure class="image contain-image card-image">
    <img [src]="imageUrl" alt="imageUrl" />
  </figure>
  <span class="card-number ods-typography-body-m-regular">{{ card.pan }}</span>
  <div class="card-button-container">
    <button
      *ngIf="canEdit"
      box-button
      [size]="'small'"
      [theme]="'insignificant'"
      (click)="onEdit($event)"
      [attr.aria-label]="'edit_' | translate"
      class="card-button-edit"
    >
      {{ 'edit_' | translate }}
    </button>
    <button
      *ngIf="canDelete"
      box-button
      [size]="'small'"
      [theme]="'insignificant'"
      [borders]="'none'"
      (click)="onDelete(card)"
      class="card-button-delete"
      [attr.aria-label]="'delete_' | translate"
    >
      {{ 'delete_' | translate }}
    </button>
  </div>
</div>
